// DEV-12306 / DEV-12398: positioning is CSS-owned now (m3/_snackbar.scss pins the
// container fixed bottom-center of the viewport and stacks toasts in a flex column).
// The old init_snackbar_container() measure-and-translate hack is gone; kept as a
// no-op because legacy sidebar-toggle handlers in site.js still call it.
function init_snackbar_container() {}


function show_snackbar({message, type = 'success', timer = 5000, onClose, autoClose = true, ...options}) {
    const $responsive_container = am.$('#page_wrapper_responsive');
    const $normal_container = am.$('#page');
    const $page = $responsive_container.length > 0 ? $responsive_container : $normal_container;
    
    var close_btn = options.show_close ? `<i class="fal fa-times btn-close" data-bs-dismiss="toast" aria-label="Close"></i>` : '';
    var from_undo = options.from_undo ? 'undo-snackbar' : '';
    // Escape the message by default: it is interpolated straight into the toast HTML below,
    // so untrusted text (server error strings, user-supplied order/partlist names, etc.) would
    // otherwise be an XSS sink. Callers that intentionally pass markup must opt in with html: true.
    var safe_message = options.html ? message : String(message == null ? '' : message)
        .replace(/[&<>"']/g, function (c) {
            return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
        });
    const $toast = am.$(`<div class="toast am-snackbar am-snackbar-${type} ${from_undo}">
                                <div class="toast-header"></div>
                                <div class="toast-body ${options.aux_class ? options.aux_class : ''}">
                                    ${safe_message}
                                    ${close_btn}
                                </div>
                        </div>`);

    const toast = new bootstrap.Toast($toast, { autohide: autoClose, delay: timer });
    toast.show();

    let $container = $page.children('#snackbar-container');

    if ($container.length === 0) {
        $page.append(`<div id="snackbar-container" class="toast-container"></div>`);
        $container = $page.children('#snackbar-container');
        $container.append(toast._element);

        var bottom = am.$('.am-button-row-sticky, .am-action-bar').length ? '70px' : '18px' ;
        $container.addClass('raise-container-'+bottom);
    }else{
        $container.append(toast._element);
    }

    am.$(toast._element).find('.btn-close').click(() => {
        if (typeof onClose === 'function') {
            onClose();
        }
    });

    toast._element.addEventListener('hidden.bs.toast', function (toast) {
        $container = am.$('#snackbar-container')
        var children = $container.children('.toast');
        am.$(toast.target).remove();
        if(children.length == 0){
            setTimeout(() => {
                $container.remove();
            }, 1500)
        }
    })
}

function clear_snackbars(aux_class=false) {
    const $snackbar_container = am.$('#snackbar-container');
    
    if (aux_class) { // Target snackbars with specific aux_class
        debugLog('clear_snackbars called with aux_class:', aux_class);
        const $target_toasts = $snackbar_container.find(`.toast .${aux_class}`).closest('.toast');
        debugLog('Found', $target_toasts.length, 'snackbars with aux_class:', aux_class);
        $target_toasts.remove();
    } else { // Clear all snackbars
        const $all_toasts = $snackbar_container.children('.toast');
        debugLog('Clearing all', $all_toasts.length, 'snackbars');
        $all_toasts.remove();
    }
}